import { render, staticRenderFns } from "./wmsFooter.vue?vue&type=template&id=2ca55594&scoped=true"
import script from "./wmsFooter.vue?vue&type=script&lang=js"
export * from "./wmsFooter.vue?vue&type=script&lang=js"
import style0 from "./wmsFooter.vue?vue&type=style&index=0&id=2ca55594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca55594",
  null
  
)

export default component.exports